import {Affiliate} from '@/utils/affiliate/config'
import {routeTo} from '@/utils/router'

type AffiliateDiscountContent = {
  name: string
  imageSrc?: string
  imageAlt?: string
  imageWidth?: number
  imageHeight?: number
  bannerTitle?: string
  bannerDescription?: string
  bannerLinkHref?: string
}

const affiliateDiscountList: Record<Affiliate, AffiliateDiscountContent> = {
  [Affiliate.tatrabanka]: {
    name: 'Tatra bank',
    imageSrc: '/images/affiliate/tatra-bank-logo.png',
    imageAlt: 'Tatra bank logo',
    imageWidth: 100,
    imageHeight: 100,
    bannerTitle: 'affiliate-tatra-bank-title',
    bannerDescription: 'affiliate-tatra-bank-desc',
    bannerLinkHref: routeTo.blog.article('verejny-prislub-tatra-banky'),
  },
  [Affiliate.ttb]: {
    name: 'Tatra bank',
    imageSrc: '/images/affiliate/tatra-bank-logo.png',
    imageAlt: 'Tatra bank logo',
    imageWidth: 100,
    imageHeight: 100,
    bannerTitle: 'affiliate-tatra-bank-title',
    bannerDescription: 'affiliate-tatra-bank-desc',
    bannerLinkHref: routeTo.blog.article('verejny-prislub-tatra-banky'),
  },
  [Affiliate.saashub]: {
    name: 'SaaSHub',
    imageSrc: '/images/affiliate/saashub-logo.png',
    imageAlt: 'SaaSHub logo',
    imageWidth: 40,
    imageHeight: 50,
  },
  [Affiliate.londonOffice]: {
    name: 'The London Office',
    imageSrc: '/images/affiliate/london-office-logo.svg',
    imageAlt: 'The London Office logo',
    imageWidth: 40,
    imageHeight: 50,
  },
  [Affiliate.businify]: {
    name: 'Businify',
    imageSrc: '/images/affiliate/businify-logo.png',
    imageAlt: 'Businify logo',
    imageWidth: 200,
    imageHeight: 34,
  },
  [Affiliate.setUpToSucceed]: {
    name: 'Set Up to Succeed with Gretta Ford',
    imageSrc: '/images/affiliate/set-up-to-succeed-logo.png',
    imageAlt: 'Set up to succeed logo',
    imageWidth: 200,
    imageHeight: 57,
  },
  [Affiliate.vliani]: {
    name: 'Vliani',
  },
  [Affiliate.ionos]: {
    name: 'Ionos',
    imageSrc: '/images/affiliate/ionos-logo.svg',
    imageAlt: 'Ionos logo',
    imageWidth: 60,
    imageHeight: 30,
  },
  [Affiliate.simoneGiertz]: {
    name: 'Simone Giertz',
    imageSrc: '/images/affiliate/simone-giertz.png',
    imageAlt: 'Photo of Simone Giertz',
    imageWidth: 200,
    imageHeight: 200,
    bannerTitle: 'affiliate-simone-giertz-title',
    bannerDescription: 'affiliate-simone-giertz-desc',
  },
  [Affiliate.monicaRazak]: {
    name: 'Monica Razak',
    imageSrc: '/images/affiliate/monica-razak.png',
    imageAlt: 'Photo of Monica Razak',
    imageWidth: 200,
    imageHeight: 200,
    bannerTitle: 'affiliate-monica-razak-title',
    bannerDescription: 'affiliate-monica-razak-desc',
  },
  [Affiliate.coleHastings]: {
    name: 'Cole Hastings',
    imageSrc: '/images/affiliate/cole-hastings.png',
    imageAlt: 'Photo of Cole Hastings',
    imageWidth: 200,
    imageHeight: 200,
    bannerTitle: 'affiliate-cole-hastings-title',
    bannerDescription: 'affiliate-cole-hastings-desc',
  },
  [Affiliate.grantRudow]: {
    name: 'Grant Rudow',
    imageSrc: '/images/affiliate/grant-rudow.png',
    imageAlt: 'Photo of Grant Rudow',
    imageWidth: 200,
    imageHeight: 200,
    bannerTitle: 'affiliate-grant-rudow-title',
    bannerDescription: 'affiliate-grant-rudow-desc',
  },
  [Affiliate.crayonCapital]: {
    name: 'Crayon Capital',
    imageSrc: '/images/affiliate/crayon-capital.png',
    imageAlt: 'Crayon Capital logo',
    imageWidth: 200,
    imageHeight: 200,
    bannerTitle: 'affiliate-crayon-capital-title',
    bannerDescription: 'affiliate-crayon-capital-desc',
  },
  [Affiliate.fbaZip]: {
    name: 'fba.zip',
    imageSrc: '/images/affiliate/fba-zip.png',
    imageAlt: 'fba.zip logo',
    imageWidth: 200,
    imageHeight: 190,
    bannerTitle: 'affiliate-fba-zip-title',
    bannerDescription: 'affiliate-fba-zip-desc',
  },
  [Affiliate.firstFormations]: {
    name: '1st Formations',
    imageSrc: '/images/affiliate/1st-formations.png',
    imageAlt: '1st Formations logo',
    imageWidth: 200,
    imageHeight: 42,
    bannerTitle: 'affiliate-1st-formations-title',
    bannerDescription: 'affiliate-1st-formations-desc',
  },
  [Affiliate.casualFinance]: {
    name: 'Casual Finance',
    imageSrc: '/images/affiliate/casual-finance.png',
    imageAlt: 'Casual Finance logo',
    imageWidth: 200,
    imageHeight: 200,
    bannerTitle: 'affiliate-casual-finance-title',
    bannerDescription: 'affiliate-casual-finance-desc',
  },
  [Affiliate.michaelGirdley]: {
    name: 'Michael Girdley',
    imageSrc: '/images/affiliate/michael-girdley.png',
    imageAlt: 'Photo of Michael Girdley',
    imageWidth: 200,
    imageHeight: 200,
    bannerTitle: 'affiliate-michael-girdley-title',
    bannerDescription: 'affiliate-michael-girdley-desc',
  },
  [Affiliate.ourCheeryCorner]: {
    name: 'Our Cheery Corner',
    imageSrc: '/images/affiliate/our-cheery-corner.png',
    imageAlt: 'Our Cheery Corner logo',
    imageWidth: 200,
    imageHeight: 200,
    bannerTitle: 'affiliate-our-cheery-corner-title',
    bannerDescription: 'affiliate-our-cheery-corner-desc',
  },
  [Affiliate.legalEagle]: {
    name: 'LegalEagle',
    imageSrc: '/images/affiliate/legal-eagle.png',
    imageAlt: 'Photo of Devin Stone',
    imageWidth: 200,
    imageHeight: 200,
    bannerTitle: 'affiliate-legal-eagle-title',
    bannerDescription: 'affiliate-legal-eagle-desc',
  },
  [Affiliate.monkeyExplains]: {
    name: 'MonkeyExplains',
    imageSrc: '/images/affiliate/monkey-explains.png',
    imageAlt: 'MonkeyExplains logo',
    imageWidth: 200,
    imageHeight: 200,
    bannerTitle: 'affiliate-monkey-explains-title',
    bannerDescription: 'affiliate-monkey-explains-desc',
  },
  [Affiliate.vantaflow]: {
    name: 'Vantaflow',
    imageSrc: '/images/affiliate/vantaflow.png',
    imageAlt: 'Vantaflow logo',
    imageWidth: 200,
    imageHeight: 190,
    bannerTitle: 'affiliate-vantaflow-title',
    bannerDescription: 'affiliate-vantaflow-desc',
  },
  [Affiliate.hfcs]: {
    name: 'HFCS',
    imageSrc: '/images/affiliate/1st-formations.png',
    imageAlt: '1st Formations logo',
    imageWidth: 200,
    imageHeight: 42,
    bannerTitle: 'affiliate-hfcs-title',
    bannerDescription: 'affiliate-hfcs-desc',
  },
  [Affiliate.loosends]: {
    name: 'Loosends',
    imageSrc: '/images/affiliate/loosends.png',
    imageAlt: 'Liam, founder of LOOSENDS',
    imageWidth: 200,
    imageHeight: 200,
    bannerTitle: 'affiliate-loosends-title',
    bannerDescription: 'affiliate-loosends-desc',
  },
  [Affiliate.taylahRose]: {
    name: 'Taylah Rose',
    imageSrc: '/images/affiliate/taylah-rose.png',
    imageAlt: 'Photo of Taylah Rose',
    imageWidth: 200,
    imageHeight: 200,
    bannerTitle: 'affiliate-taylah-rose-title',
    bannerDescription: 'affiliate-taylah-rose-desc',
  },
  [Affiliate.earlyExit]: {
    name: 'Early Exit',
    imageSrc: '/images/affiliate/early-exit.png',
    imageAlt: 'Early Exit logo',
    imageWidth: 200,
    imageHeight: 200,
    bannerTitle: 'affiliate-early-exit-title',
    bannerDescription: 'affiliate-early-exit-desc',
  },
}

export const useAffiliateContent = () => ({
  affiliateDiscountList: affiliateDiscountList,
  generalBannerTitle: 'affiliate-banner-general-title',
  generalBannerDescription: 'affiliate-banner-general-desc',
  staticPriceBannerDescription: 'affiliate-banner-static-price-desc',
  closeButtonText: 'close-btn-text',
  automaticallyAppliedDiscountDescription: 'discount-automatically-applied',
  appliedDiscountDescription: 'discount-applied',
  removedDiscountDescription: 'discount-removed',
})
